import { generatePaginatedDataQuery, GetTaxonsResponse, syliusFetch } from '../../../entities/@api/Sylius';
import { transformTaxonResourceToProductCategoryBaseWithChildren } from '../../../entities/@products/ProductCategory/ProductCategoryTransformers';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { generateIdArray } from '../../../helpers/array';
import { ReduxFetchAction } from '../../defaults';
import {
    setError,
    setHasFetched,
    setIsLoading,
    setIsSuccessful,
    setProductCategories,
} from './productCategoriesSlice';

export const fetchProductCategorySlugs: ReduxFetchAction = () => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setProductCategories([]));

    try {
        const pageSize = 50;
        const query = generatePaginatedDataQuery(1, pageSize);
        const taxonsResponse = await syliusFetch<GetTaxonsResponse>(`/shop/taxons?${query}`);

        if (!isFetchResultSuccessful(taxonsResponse)) {
            dispatch(setError(taxonsResponse.error));
            return;
        }

        const taxonResources = taxonsResponse.data['hydra:member'];
        const totalItems = taxonsResponse.data['hydra:totalItems'];

        const extraResourceSets = taxonResources.length > 0
            ? Math.ceil(totalItems / taxonResources.length) - 1
            : 0;

        const extraResourcesToFetch = generateIdArray(extraResourceSets).map(page => page + 2);

        let resources = taxonResources;

        const productCategoryPageFetchPromises = extraResourcesToFetch.map(async pageNumber => {
            const pageQuery = generatePaginatedDataQuery(pageNumber);
            const pageResponse = await syliusFetch<GetTaxonsResponse>(`/shop/taxons?${pageQuery}`);

            if (!isFetchResultSuccessful(pageResponse)) {
                dispatch(setError(pageResponse.error));
                return;
            }

            const pageTaxonResources = pageResponse.data['hydra:member'];

            resources = [...resources, ...pageTaxonResources];
        });

        await Promise.allSettled(productCategoryPageFetchPromises);

        const productCategories = resources.flatMap(transformTaxonResourceToProductCategoryBaseWithChildren);

        dispatch(setProductCategories(productCategories));
        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchProductCategorySlugs]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};
